import { generateClient } from "aws-amplify/api";

const client = generateClient();

import { list_announcement } from '@/graphql/queries'

export default {
  data() {
    return {
      announcementsList: [],
    }
  },
  methods: {
    async fetchAnnouncements() {
      try {
        const response = await client.graphql({
          query: list_announcement,
          variables: {
            input: {
              
              announcement_source: 'BMS',
              limit: 100,
              next_token: null,
            }
          }
        })
        let responseData = JSON.parse(response.data.list_announcement)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.announcementsList = responseData.data || []
        } else {
          this.announcementsList = []
        }
        // console.log(this.announcementsList)
      } catch (error) {
        console.error("Error fetching announcements:", error);
        this.announcementsList = [];
        throw error;
      }
    },
  },
};
